import { render, staticRenderFns } from "./vendorProcedures.vue?vue&type=template&id=76c72e54&scoped=true&"
import script from "./vendorProcedures.vue?vue&type=script&lang=js&"
export * from "./vendorProcedures.vue?vue&type=script&lang=js&"
import style0 from "./vendorProcedures.vue?vue&type=style&index=0&id=76c72e54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c72e54",
  null
  
)

component.options.__file = "vendorProcedures.vue"
export default component.exports